// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file luwu/v1/common.proto (package luwu.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file luwu/v1/common.proto.
 */
export const file_luwu_v1_common: GenFile = /*@__PURE__*/
  fileDesc("ChRsdXd1L3YxL2NvbW1vbi5wcm90bxIHbHV3dS52MSI6CgVFcnJvchIgCgRjb2RlGAEgASgOMhIubHV3dS52MS5FcnJvckNvZGUSDwoHbWVzc2FnZRgCIAEoCSqGAgoJRXJyb3JDb2RlEhoKFkVSUk9SX0NPREVfVU5TUEVDSUZJRUQQABIXChNFUlJPUl9DT0RFX0lOVEVSTkFMEAESFgoSRVJST1JfQ09ERV9JTlZBTElEEAISGAoURVJST1JfQ09ERV9OT1RfRk9VTkQQAxIVChFFUlJPUl9DT0RFX0RFTklFRBAEEhUKEUVSUk9SX0NPREVfRVhJU1RTEAUSGwoXRVJST1JfQ09ERV9PVVRTSURFX1JPT1QQBhIYChRFUlJPUl9DT0RFX1RPT19MQVJHRRAHEhEKDUVSUk9SX0NPREVfSU8QCBIaChZFUlJPUl9DT0RFX1VOU1VQUE9SVEVEEAlCKFombHV3dS5kZXYvZ28vaW50ZXJuYWwvcGIvbHV3dS92MTtsdXd1djFiBnByb3RvMw");

/**
 * @generated from message luwu.v1.Error
 */
export type Error = Message<"luwu.v1.Error"> & {
  /**
   * @generated from field: luwu.v1.ErrorCode code = 1;
   */
  code: ErrorCode;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message luwu.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error> = /*@__PURE__*/
  messageDesc(file_luwu_v1_common, 0);

/**
 * @generated from enum luwu.v1.ErrorCode
 */
export enum ErrorCode {
  /**
   * @generated from enum value: ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ERROR_CODE_INTERNAL = 1;
   */
  INTERNAL = 1,

  /**
   * @generated from enum value: ERROR_CODE_INVALID = 2;
   */
  INVALID = 2,

  /**
   * @generated from enum value: ERROR_CODE_NOT_FOUND = 3;
   */
  NOT_FOUND = 3,

  /**
   * @generated from enum value: ERROR_CODE_DENIED = 4;
   */
  DENIED = 4,

  /**
   * @generated from enum value: ERROR_CODE_EXISTS = 5;
   */
  EXISTS = 5,

  /**
   * @generated from enum value: ERROR_CODE_OUTSIDE_ROOT = 6;
   */
  OUTSIDE_ROOT = 6,

  /**
   * @generated from enum value: ERROR_CODE_TOO_LARGE = 7;
   */
  TOO_LARGE = 7,

  /**
   * @generated from enum value: ERROR_CODE_IO = 8;
   */
  IO = 8,

  /**
   * @generated from enum value: ERROR_CODE_UNSUPPORTED = 9;
   */
  UNSUPPORTED = 9,
}

/**
 * Describes the enum luwu.v1.ErrorCode.
 */
export const ErrorCodeSchema: GenEnum<ErrorCode> = /*@__PURE__*/
  enumDesc(file_luwu_v1_common, 0);

